import { CalendarOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip, Typography } from 'antd';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import {
  EDIT_EMPLOYEE_PATH,
  KEY,
  U_ACTION,
  U_NAME,
  U_SCHEDULE,
  U_SERVICES,
} from '@app/constants';
import type { NAnalytics } from '@app/types';
import { shortName } from '@app/utils';

export const adaptDataToTable = (
  data: NAnalytics.ModelEmployeeLite[],
  handleEdit: (id: number) => void,
  navigate: (path: string) => void,
  hasRightToWorkSchedule: boolean,
  hasUserRightToEdit: boolean
) => {
  return data.map((employee: NAnalytics.ModelEmployeeLite) => {
    const {
      Id,
      IsBelongToCurrentBranch,
      CountClientServices,
      NameFirst,
      NameLast,
      Position,
      IsDeleted,
      WorkScheduleTill,
    } = employee;
    const handleName = NameFirst
      ? shortName(NameLast ? `${NameLast} ${NameFirst}` : NameFirst, true)
      : 'Неизвестное имя';

    const transformDate = (isoDate: string | null) => {
      if (isoDate) {
        const date = new Date(isoDate);
        const LocalDate = date.toLocaleDateString('ru-RU', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
        const dateParts = LocalDate.split(' ');
        const [day, month, year] = dateParts;
        const formattedDate = `${day} ${month} ${year}`;
        return formattedDate;
      }
    };

    return {
      [KEY]: String(Id),
      [U_NAME]: (
        <div
          style={{ minWidth: '150px' }}
          className={cn({ 'deleted-cell': IsDeleted })}
        >
          <Link
            to={`${EDIT_EMPLOYEE_PATH}?id=${Id}&key=1`}
            data-testid="employee-name"
          >
            {handleName}
            <br />
          </Link>
          <Typography.Text type="secondary" data-testid="employee-position">
            {Position}
          </Typography.Text>
          {IsDeleted && (
            <span style={{ color: 'red' }}>{Position && <br />}В архиве</span>
          )}
        </div>
      ),
      [U_SERVICES]: (
        <div className={cn({ 'deleted-cell': IsDeleted })}>
          <Link
            to={`${EDIT_EMPLOYEE_PATH}?id=${Id}&key=5`}
            data-testid="employee-service"
          >
            {String(CountClientServices)}
          </Link>
        </div>
      ),
      [U_SCHEDULE]: (
        <div
          className={cn({ 'deleted-cell': IsDeleted })}
          data-testid="employee-schedule"
        >
          {transformDate(WorkScheduleTill)}
        </div>
      ),
      [U_ACTION]: (
        <Space>
          {hasUserRightToEdit && (
            <Tooltip title="Редактировать">
              <Button
                icon={<EditOutlined />}
                onClick={() => handleEdit(Id)}
                data-testid="edit-employee"
              />
            </Tooltip>
          )}
          {IsBelongToCurrentBranch && hasRightToWorkSchedule && (
            <Tooltip title="График работы">
              <Button
                icon={<CalendarOutlined />}
                onClick={() =>
                  navigate(`/schedule?mode=addition&employee-id=${Id}`)
                }
                data-testid="schedule-employee"
              />
            </Tooltip>
          )}
        </Space>
      ),
    };
  });
};
